import {writable} from "svelte/store";

export const eventBus = writable([]);
